import { useCallback } from 'react';

type AnalyticsPayload = Record<string, unknown>;

interface AnalyticsClient {
  track: (eventName: string, payload?: AnalyticsPayload) => void;
}

declare global {
  interface Window {
    analytics?: AnalyticsClient;
  }
}

export const useAnalytics = () => {
  const track = useCallback((eventName: string, payload: AnalyticsPayload = {}) => {
    const client = typeof window !== 'undefined' ? window.analytics : undefined;

    if (client?.track) {
      client.track(eventName, payload);
      return;
    }

    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', eventName, payload);
    }
  }, []);

  return { track };
};
